/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import * as actionTypes from "../actions/pageActionTypes";

const pageContextReducer = (
  state = { appSideBarOpen: true, appTopBarOpen: true },
  action
) => {
  switch (action.type) {
    case actionTypes.PAGE_CONTEXT_CHANGED:
      let newContext = action.pageContext ? action.pageContext : {};
      return { ...state, ...newContext };
    default:
      return state;
  }
};

export default pageContextReducer;
